<script>
  import { TextInput } from "carbon-components-svelte";
  export let placeholder;
  export let value;
</script>

<div>
  <TextInput hideLabel {placeholder} maxlength="10" bind:value />
</div>
<div class="input-counter">
  <span>{value.length}</span>/<spen>10</spen>
</div>

<style>
  .input-counter {
    display: flex;
    justify-content: flex-end;
    font-size: 12px;
    color: #8d8d8d;
  }
</style>
